import { getStore } from '../store/store';
import { TodoFolder } from 'owa-todo-types';

export function getFolders(): TodoFolder[] {
    return [...getStore().folders.values()];
}
